export enum FinalPaymentConfigurationEnum {
  DoNotPay = 0,
  PayFullPeriod = 1,
  PayPartialPeriodAmount = 2,
}
